import {
  ClipboardCheck,
  ClipboardList,
  Crown,
  Database,
  FileClock,
  Gift,
  Home,
  Menu,
  PackageSearch,
  Settings,
  TestTube2,
  Users,
  X
} from "lucide-react";
import { isLocalDevFrontend } from "../../lib/env";

const navItems = [
  { href: "/admin", label: "後台總覽", icon: Home },
  { href: "/admin/members", label: "會員管理", icon: Users },
  { href: "/admin/deposits", label: "充值紀錄", icon: Database },
  { href: "/admin/rewards", label: "派發中心", icon: Gift },
  { href: "/admin/reviews", label: "審核中心", icon: ClipboardCheck },
  { href: "/admin/red-packet-v2", label: "紅包 V2 查詢", icon: Gift },
  { href: "/admin/invite", label: "邀友管理", icon: ClipboardList },
  { href: "/admin/crawler", label: "爬蟲資料 / 贈禮小幫手", icon: Database },
  { href: "/admin/assets", label: "資產查詢", icon: PackageSearch },
  { href: "/admin/level", label: "公會等級", icon: Crown },
  { href: "/admin/settings", label: "活動設定", icon: Settings },
  { href: "/admin/logs", label: "操作紀錄", icon: FileClock },
  { href: "/admin/test-data", label: "測試資料", icon: TestTube2 }
];

export function AdminSidebar({ open, onClose, onToggle }: { open: boolean; onClose: () => void; onToggle: () => void }) {
  const path = window.location.pathname;
  const isLocalDev = isLocalDevFrontend();
  const visibleNavItems = isLocalDev ? navItems : navItems.filter((item) => item.href !== "/admin/test-data");

  return (
    <>
      <button className="admin-mobile-menu" type="button" onClick={onToggle} aria-label={open ? "關閉選單" : "開啟選單"}>
        {open ? <X size={20} /> : <Menu size={20} />}
      </button>
      <aside className={`admin-sidebar ${open ? "open" : ""}`}>
        <div className="admin-brand">
          <span>LLC</span>
          <div>
            <strong>龍來喬後台</strong>
            <small>營運管理</small>
          </div>
        </div>
        <nav className="admin-nav">
          {visibleNavItems.map((item) => {
            const Icon = item.icon;
            const active = path === item.href || (item.href !== "/admin" && path.startsWith(`${item.href}/`));
            return (
              <a className={active ? "active" : ""} href={item.href} key={item.href} onClick={onClose}>
                <Icon size={18} />
                <span>{item.label}</span>
              </a>
            );
          })}
        </nav>
        {isLocalDev ? (
          <div className="admin-sidebar-note">
            <strong>Local dev 模式</strong>
            <span>測試資料與本機 state 僅供開發驗證。</span>
          </div>
        ) : null}
      </aside>
      {open ? <button className="admin-sidebar-backdrop" type="button" onClick={onClose} aria-label="關閉側邊選單" /> : null}
    </>
  );
}
